// src/redux/reducers/promptReducer.js
import { PROMPT_REQUEST, PROMPT_SUCCESS, PROMPT_FAIL } from '../constants/promptConstants'

export const getPromptListDataReducer = (
  state = { loading: false, data: {}, error: null },
  action
) => {
  switch (action.type) {
    case PROMPT_REQUEST:
      return { ...state, loading: true, error: null }
    case PROMPT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null }
    case PROMPT_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
